// ---------------------------------------------------------------------------
// Identidade anônima do visitante + origem da visita.
// Nenhum dado pessoal (nome, e-mail, telefone): é só um sorteio do aparelho.
// Se a pessoa limpar o navegador, vira outra pessoa — tudo bem, é assim mesmo.
// ---------------------------------------------------------------------------

import { ehAppInstalado } from './navegador';
import { supabase } from './supabase';

const CHAVE_VISITANTE = 'slc_visitante';
const CHAVE_ORIGEM = 'slc_origem';

export function idDoVisitante(): string {
  let v = localStorage.getItem(CHAVE_VISITANTE);
  if (!v) {
    v = crypto.randomUUID();
    localStorage.setItem(CHAVE_VISITANTE, v);
  }
  return v;
}

export function origemDaVisita(): string {
  const params = new URLSearchParams(location.search);
  // Chegou por um aviso push? Conta como origem "push".
  const origem = params.get('origem');
  if (origem) return origem.toLowerCase();
  const p = params.get('de');
  if (p) return p.toLowerCase();
  // Aberto pelo app instalado na tela inicial.
  if (ehAppInstalado) return 'app';
  const r = document.referrer || '';
  if (/whatsapp|wa\.me/i.test(r)) return 'whatsapp';
  if (/instagram/i.test(r)) return 'instagram';
  if (/facebook|fb\./i.test(r)) return 'facebook';
  if (/google|bing/i.test(r)) return 'google';
  if (!r) return 'direto';
  return 'outro';
}

// Guarda a origem na primeira vez e reusa nas próximas: quem veio do
// WhatsApp continua contando como WhatsApp mesmo que depois volte direto.
export function origemDaVisitaGuardada(): string {
  let o = localStorage.getItem(CHAVE_ORIGEM);
  if (!o) {
    o = origemDaVisita();
    localStorage.setItem(CHAVE_ORIGEM, o);
  }
  return o;
}

// Origem POR EVENTO. Um link marcado (?de=... ou ?origem=...) sempre vence e fica
// guardado para aquele evento. Sem marca: usa o que já foi guardado para aquele
// evento; senão, descobre agora.
export function origemDoEvento(slug: string): string {
  const chave = `slc_origem_${slug}`;
  try {
    const params = new URLSearchParams(location.search);
    const marcada = (params.get('de') || params.get('origem') || '').trim().toLowerCase();
    if (marcada) {
      localStorage.setItem(chave, marcada);
      return marcada;
    }
    const guardada = localStorage.getItem(chave);
    if (guardada) return guardada;
    const agora = origemDaVisita();
    localStorage.setItem(chave, agora);
    return agora;
  } catch {
    return 'direto';
  }
}

// Anota a visita. Fogo e esquece: NUNCA pode dar erro na tela nem atrasar a compra.
export function anotarVisita(slug: string | null | undefined): void {
  if (!slug) return;
  try {
    const visitante = idDoVisitante();
    void supabase
      .rpc('registrar_visita', { p_slug: slug, p_visitante: visitante, p_origem: origemDoEvento(slug) })
      .then(({ error }) => {
        if (error) console.warn('registrar_visita', error);
      })
      .catch(() => {
        /* ignora */
      });
  } catch {
    /* sem armazenamento no navegador (aba privada etc.): simplesmente não conta */
  }
}